import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import { AddonConfigProvider } from './contexts/AddonConfigContext';
import { CustomDialogContainer } from './components/CustomDialog';
import { Capacitor } from '@capacitor/core';

// Capacitor 네이티브 앱 환경일 경우 fetch 인터셉트 (상대 경로를 절대 경로로 변환)
if (Capacitor.isNativePlatform()) {
  const API_BASE = import.meta.env.VITE_API_BASE_URL || 'https://api.ezoptix.ai';

  const originalFetch = window.fetch;
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    let finalInput = input;
    if (typeof input === 'string' && input.startsWith('/api')) {
      finalInput = API_BASE + input;
    }
    return originalFetch(finalInput, init);
  };
}

// Official Release Console Log (고객 지원 및 세션 추적용)
try {
  const prodVer = typeof __APP_PRODUCT_VERSION__ !== 'undefined' ? __APP_PRODUCT_VERSION__ : '1.0';
  const buildVer = typeof __APP_BUILD_VERSION__ !== 'undefined' ? __APP_BUILD_VERSION__ : '1.134.3';
  console.info(
    `%c[EZOptix] Official v${prodVer} %c(Build ${buildVer})`,
    'color: #00f0ff; font-weight: bold; font-size: 11px;',
    'color: #94a3b8; font-size: 10px;'
  );
} catch (_) { }

import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <AddonConfigProvider>
        <App />
        <CustomDialogContainer />
      </AddonConfigProvider>
    </GlobalErrorBoundary>
  </StrictMode>,
);
